/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

@observer
class ChooseProductSecondHeadComponent extends React.Component {
  constructor(props) {
    super(props);

    this.sortLabelInterestsByTermInterestAvailable = this.sortLabelInterestsByTermInterestAvailable.bind(this);
    this.sortLabelInterestsByInitialInterest = this.sortLabelInterestsByInitialInterest.bind(this);
    this.sortLabelInterestsByTermInterest = this.sortLabelInterestsByTermInterest.bind(this);
  }

  sortLabelInterestsByTermInterestAvailable() {
    const {
      sortLabelInterestsByTermInterestAvailable,
    } = this.props.ToolOverviewData;

    this.props.CalculationFormData.labelInterests = sortLabelInterestsByTermInterestAvailable(
      this.props.CalculationFormData.labelInterests);
  }

  sortLabelInterestsByInitialInterest() {
    const {
      sortLabelInterestsByInitialInterest,
      sortedFixedRateTerm,
    } = this.props.ToolOverviewData;

    this.props.CalculationFormData.labelInterests = sortLabelInterestsByInitialInterest(sortedFixedRateTerm,
      this.props.CalculationFormData.labelInterests);
  }

  sortLabelInterestsByTermInterest() {
    const {
      sortLabelInterestsByTermInterest,
      sortedFixedRateTerm,
    } = this.props.ToolOverviewData;

    this.props.CalculationFormData.labelInterests = sortLabelInterestsByTermInterest(sortedFixedRateTerm,
      this.props.CalculationFormData.labelInterests);
  }

  render() {
    const {
      sortedFixedRateTerm,
      sortedOverviewTableColumn,
    } = this.props.ToolOverviewData;

    const sortedInitialInterestClassName = sortedOverviewTableColumn === 'initialInterest' && 'extra-bold underline';
    const sortedAverageInterestClassName = sortedOverviewTableColumn === 'averageInterest' && 'extra-bold underline';
    const sortedAverageInterestAvailableClassName = (
      sortedOverviewTableColumn === 'averageInterestAvailable' && 'underline'
    );

    return (
      <thead>
        <tr>
          <th
            className="choose-product-table__dark-thead bold"
            colSpan={3}
          >
            Verstrekker
          </th>
          <th
            className={`choose-product-table__light-thead normal ${sortedInitialInterestClassName}`}
            colSpan={1}
            onClick={() => {
              this.sortLabelInterestsByInitialInterest(sortedFixedRateTerm);
            }}
          >
            Aanvangsrente
          </th>
          <th
            className={`choose-product-table__light-thead normal ${sortedAverageInterestClassName}`}
            colSpan={1}
            onClick={() => {
              this.sortLabelInterestsByTermInterest(sortedFixedRateTerm);
            }}
          >
            Looptijdrente
          </th>
          <th
            className={`choose-product-table__dark-thead ${sortedAverageInterestAvailableClassName}`}
            colSpan={1}
            onClick={this.sortLabelInterestsByTermInterestAvailable}
          >Looptijdrente</th>
          <th className={'choose-product-table__dark-thead'} />
        </tr>
      </thead>
    );
  }
}

ChooseProductSecondHeadComponent.propTypes = {
  ToolOverviewData: PropTypes.shape({
    sortedOverviewTableColumn: PropTypes.string,
    sortLabelInterestsByInitialInterest: PropTypes.func,
    sortLabelInterestsByTermInterest: PropTypes.func,
    sortLabelInterestsByTermInterestAvailable: PropTypes.func,
    sortedFixedRateTerm: PropTypes.number,
  }),
  CalculationFormData: PropTypes.shape({
    labelInterests: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

ChooseProductSecondHeadComponent.defaultProps = {
  ToolOverviewData: {
    sortedOverviewTableColumn: '',
    sortLabelInterestsByTermInterest: () => {},
    sortLabelInterestsByInitialInterest: () => {},
    sortLabelInterestsByTermInterestAvailable: () => {},
    sortedFixedRateTerm: 0,
  },
  CalculationFormData: {
    labelInterests: [],
  },
};

export default inject('ToolOverviewData', 'CalculationFormData')(ChooseProductSecondHeadComponent);
